import { NotLoggedInToWorkspaceError } from '@lucidlink/sdk';
import { ForbiddenError } from '@lucidlink/sdk/fetcher';
import { clearWorkspaceData, refetchCurrentMember } from './actions';
// TODO: https://lucidlink.atlassian.net/browse/LUCID-27705
const errorMap = new Map([
    [ForbiddenError, [refetchCurrentMember]],
    [NotLoggedInToWorkspaceError, [clearWorkspaceData]],
]);
export const handleErrors = async ({ error, params, }) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Type
    for (const [HandledErrorType, handlers] of errorMap) {
        if (error instanceof HandledErrorType) {
            for (const handler of handlers) {
                await handler({ error, params });
            }
        }
    }
};
